exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-app-terms-tsx": () => import("./../../../src/pages/app-terms.tsx" /* webpackChunkName: "component---src-pages-app-terms-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-privacy-tsx": () => import("./../../../src/pages/privacy.tsx" /* webpackChunkName: "component---src-pages-privacy-tsx" */),
  "component---src-pages-tos-consent-tsx": () => import("./../../../src/pages/tos-consent.tsx" /* webpackChunkName: "component---src-pages-tos-consent-tsx" */)
}

